




import { Component, Prop, Vue } from 'vue-property-decorator';
import TranslationSource from '@/types/i18n/TranslationSource';

@Component
export default class Translation extends Vue {
  @Prop(Array)
  private lang!: TranslationSource;

  @Prop(String)
  public path!: string;

  public get message(): string {
    const properties = this.path.split('.');
    return properties.reduce((prev, curr) => prev && prev[curr], this.lang[0] as any);
  }
}
